/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeePayDetails } from './EmployeePayDetails';
import {
    EmployeePayDetailsFromJSON,
    EmployeePayDetailsFromJSONTyped,
    EmployeePayDetailsToJSON,
    EmployeePayDetailsToJSONTyped,
} from './EmployeePayDetails';

/**
 * 
 * @export
 * @interface ShowEmployeePayDetailResponse
 */
export interface ShowEmployeePayDetailResponse {
    /**
     * 
     * @type {EmployeePayDetails}
     * @memberof ShowEmployeePayDetailResponse
     */
    data: EmployeePayDetails;
}

/**
 * Check if a given object implements the ShowEmployeePayDetailResponse interface.
 */
export function instanceOfShowEmployeePayDetailResponse(value: object): value is ShowEmployeePayDetailResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowEmployeePayDetailResponseFromJSON(json: any): ShowEmployeePayDetailResponse {
    return ShowEmployeePayDetailResponseFromJSONTyped(json, false);
}

export function ShowEmployeePayDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowEmployeePayDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeePayDetailsFromJSON(json['data']),
    };
}

  export function ShowEmployeePayDetailResponseToJSON(json: any): ShowEmployeePayDetailResponse {
      return ShowEmployeePayDetailResponseToJSONTyped(json, false);
  }

  export function ShowEmployeePayDetailResponseToJSONTyped(value?: ShowEmployeePayDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeePayDetailsToJSON(value['data']),
    };
}

